import axios from 'axios';
import { TRAINERS_LIST } from '../paths';

export const getTrainersList = async () => {
  const response = await axios.get(TRAINERS_LIST);
  const results = response.data;
  return results;
};
